<template lang="html">
  <div class="manual-wrapper-wrapper">
    <div class="single-manual">
      <manual :auto="true" :manualInfo="manualInfo" />
    </div>
    <div class="single-manual">
      <manual :auto="true" :manualInfo="manualInfo2" />
    </div>
  </div>
</template>

<script>
import Manual from '@/components/manual/manual.vue'
export default {
  name: 'manualWrapper',
  components: {
    Manual
  },
  data () {
    return {
      manualInfo: {
        manualSteps: [{
          manualTitle: 'main.moto',
          stepIndex: 'manual.manualIndex1',
          stepTitle: 'manual.register2',
          stepDescription: 'manual.1.1',
          hidden: true
        },
        {
          manualTitle: 'main.moto',
          stepIndex: 'manual.manualIndex2',
          stepTitle: 'manual.buy',
          stepDescription: 'manual.1.2',
          hidden: true
        },
        {
          manualTitle: 'main.moto',
          stepIndex: 'manual.manualIndex3',
          stepTitle: 'manual.save',
          stepDescription: 'manual.1.3',
          hidden: true
        }]
      },
      manualInfo2: {
        manualSteps: [{
          manualTitle: 'main.moto2',
          stepIndex: 'manual.manualIndex1',
          stepTitle: 'manual.register',
          stepDescription: 'manual.2.1',
          hidden: true
        },
        {
          manualTitle: 'main.moto2',
          stepIndex: 'manual.manualIndex2',
          stepTitle: 'manual.sell',
          stepDescription: 'manual.2.2',
          hidden: true
        },
        {
          manualTitle: 'main.moto2',
          stepIndex: 'manual.manualIndex3',
          stepTitle: 'manual.earn',
          stepDescription: 'manual.2.3',
          hidden: true
        }]
      }
    }
  },
  computed: {
    compManualInfo: {
      get: function () {
        return this.manualInfo.manualInfo
      },
      set: function () {
        console.log('set')
        this.manualInfo.manualSteps = new Array(...this.manualInfo.manualSteps)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.manual-wrapper-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;

  .single-manual {
    width: calc( 50% - 20px );
    background: rgba(255, 255, 255, 1);
    // opacity: 0.5;
  }
}
@media only screen and (max-width: 768px) {
  .manual-wrapper-wrapper {
    flex-direction: column;

    .manual-wrapper {
      padding: 20px 20px;
    }
    .single-manual {
      width: 100%;
    }
    .single-manual:first-child {
      margin-bottom: 20px;
    }
  }
}
</style>
